import * as Oazapfts from "oazapfts/lib/runtime";
import { handleApiCall } from "../util/ApiResponseUtil";
import { AuthzApi } from "../AuthzApi";
import {ApiError} from "../../model/ApiError";
export const defaults: Oazapfts.RequestOpts = {
  baseUrl: "http://localhost:8080",
};
const oazapfts = Oazapfts.runtime(defaults);
class RealAuthz implements AuthzApi {
  initialize(initProvider: (name: string) => string): void {

    defaults.baseUrl = initProvider("authzApiBase");
    defaults.headers = {};
    defaults.headers["Authorization"] = "Bearer " + initProvider("accessToken");
    defaults.cache = "no-cache";
  }

  /**
   *
   */
  releaseLicenseConsumptionById(ids: string[]): Promise<any> {
    const idstring = ids.join('&');
    return handleApiCall(
        oazapfts.fetchJson<
            | {
          status: 200;
          data: any;
        }
            | {
          status: 404;
          data: ApiError;
        }
            | {
          status: number;
          data: ApiError;
        }
        >(
            `.json?release&${idstring}`
        )
    );
  };
}
export default RealAuthz;
